// extracted by mini-css-extract-plugin
module.exports = {"title":"ChatWithBrand__title___142eV"};